// Vendors entry point for Vite build
// This file imports all vendor dependencies to create vendors.min.js

// GSAP
import "../../vendors/gsap/gsap.min.js";
import "../../vendors/gsap/ScrollTrigger.min.js";

// Lazysizes
import "../../vendors/lazysizes/lazysizes.min.js";

// Owl Carousel 2 (jQuery plugin; expects window.jQuery from WordPress)
import "../../vendors/owl-carousel/owl.carousel.min.js";

console.log("Vendors loaded");
